
import {
    CORE_GET_ALL_COMPANY_REQUEST,
    CORE_GET_ALL_COMPANY_SUCCESS,
    CORE_GET_ALL_COMPANY_FAILURE,

    CORE_CHANGE_USER_PROFILE_REQUEST,
    CORE_CHANGE_USER_PROFILE_SUCCESS,
    CORE_CHANGE_USER_PROFILE_FAILURE,

    CORE_GET_COMPANY_BY_ID_REQUEST,
    CORE_GET_COMPANY_BY_ID_SUCCESS,
    CORE_GET_COMPANY_BY_ID_FAILURE,
} from '../types'
import { REQUEST_STATE } from '../types';
const requestState = REQUEST_STATE;

export default {
    allCompany: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_COMPANY_REQUEST:
                return state;
            case CORE_GET_ALL_COMPANY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_ALL_COMPANY_FAILURE:
                return [];
            default:
                return state;
        }
    },

    companyById: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_COMPANY_BY_ID_REQUEST:
                return state;
                case CORE_GET_COMPANY_BY_ID_SUCCESS:
                    if (action.payload) {
                        const { result, data } = action.payload;
                        if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_GET_COMPANY_BY_ID_FAILURE:
                return [];
            default:
                return state;
        }
    },

    updateImg: (state = requestState, action) => {
        switch (action.type) {
            case CORE_CHANGE_USER_PROFILE_REQUEST:
                return state;
            case CORE_CHANGE_USER_PROFILE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_CHANGE_USER_PROFILE_FAILURE:
                return {};
            default:
                return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCompanyAPI.js